import { axiosRequestGET } from './serviceConfig';

export const getPlaybackTokenService = (elementId) => {
  return axiosRequestGET(`/api/media/token/playback/${elementId}`);
};
